import { initializeDataDictionaryDrawer } from "./data-dictionary-drawer"

export async function UpdateDataDictionaryTable(tableData) {
    const tableNode = document.getElementById("dataDictionaryTable")
    const newTbody = createTbody(tableData.dataElements)
    const oldTbody = tableNode.querySelector("tbody")
    if (oldTbody) {
        oldTbody.remove()
    }
    tableNode.appendChild(newTbody)
    initializeDataDictionaryDrawer()
}

function createTbody(dataElements) {
    const tbody = document.createElement("tbody")
    tbody.classList.add("font-roboto")
    tbody.innerHTML = dataElements.map((row) => createTableRow(row)).join("")
    return tbody
}

function createTableRow(rowData) {
    return `
     <tr class="hover:bg-grey-50 hover:text-green-600" id="${rowData.id}">
        <td class="first:border-l last:border-r border-r-0 px-2 py-4" data-name="${rowData.name}">
            ${rowData.name}
        </td>
        <td class="first:border-l last:border-r border-r-0 px-2 py-4" data-description="${
            rowData.description ? rowData.description : ""
        }">
            ${
                rowData.description.length > 88
                    ? rowData.description.substring(0, 88) + "..."
                    : rowData.description
            }
        </td>
        <td class="text-center content-center first:border-l last:border-r border-r-0 px-2 py-4" data-type="${
            rowData.dataType ? rowData.dataType.name : ""
        }">
            ${
                rowData.dataType
                    ? `<button class="btn btn--tag cursor-pointer pointer-events-none bg-transparent" tabindex="-1"  data-type="${rowData.dataType.name}">${rowData.dataType.name}</button>`
                    : ""
            }
        </td>
        <td class="first:border-l last:border-r border-r-0 px-2 py-4">
            <button data-element-id="${rowData.id}" class="text-link openDrawerBtn">
                View details
            </button>
        </td>
    </tr>
    `
}
